<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="auth_acceptor_tooltip_name"
      :name="auth_acceptor_tooltip_name" :description="auth_acceptor_tooltip_description"
      :editable="editable"></tool-tip>

    <div class="row justify-content-center">
      <div class="col-sm-6 signature_content_padding_top">
        <base-input label=" Name (Last, First, MI, Rank / Title)">
          <base-input :value="true" :disabled="checkForPartnerNationCondition || isReadOnly || isAuthorized"
            v-model="authorizedAcceptor.acceptorName" name="authorizedAcceptorName" v-validate="'required|max:300'"
            data-vv-as="Name" :error="getError('authorizedAcceptorName')">
          </base-input>
        </base-input>
      </div>
      <div class="col-sm-6 signature_content_padding_top">
        <base-input label="Accepting Unit / Office">
          <base-input :value="false" :disabled="checkForPartnerNationCondition || isReadOnly || isAuthorized"
            v-model="authorizedAcceptor.acceptorUnitOffice" name="acceptingUnitOffice" v-validate="'required|max:300'"
            data-vv-as="Accepting Unit / Office" :error="getError('acceptingUnitOffice')">
          </base-input>
        </base-input>
      </div>
      <div class="col-sm-6 signature_content_padding_top">
        <label>Accepting Nation / Organization</label>
        <v-select :disabled="checkForPartnerNationCondition || isReadOnly || isAuthorized"
          v-model="authorizedAcceptor.acceptorOrganizationId" :reduce="(organization) => organization.id"
          name="acceptingNationOrganization" :options="authorizedAcceptor.organizations" label="name"
          placeholder="Select one" data-vv-as="Accepting Nation / Organization"
          :class="errors.has('acceptingNationOrganization') ? 'has-danger' : ''" v-validate="'required'"
          :error="getError('acceptingNationOrganization')"></v-select>
        <span v-show="errors.has('acceptingNationOrganization')" class="error">Accepting Nation / Organization is
          required
        </span>
      </div>
      <div class="col-sm-6 signature_content_padding_top">
        <verify-pin v-if="isSigned" :checkForPartnerNationCondition="checkForPartnerNationCondition"
          :isPartnerAccount="isPartnerAccount" :isReadOnly="isReadOnly" v-on:pinVerify="pinVerify" />
        <AlertSignature ref="alertAuthorizedAcceptorSignatureGraphical" :headerText="'Authorized Acceptor Signature'"
          :module="'authorizedAcceptor'" :action="'getAuthorizedAcceptor'" activeTab="TEXT"
          :signatureData="authorizedAcceptor.acceptorSignature" v-on:onUpload="fileUploaded" v-on:onSigned="onSigned"
          :fileTypeId="1" :textDisabled="checkForPartnerNationCondition || isAuthorized || isReadOnly"
          :isPinVerified="isPinVerificationDone"
          :drawDisabled="checkForPartnerNationCondition || isAuthorized || isReadOnly"
          :uploadDisabled="isPartnerAccount || isAuthorized || isReadOnly"
          :certificateDisabled="isPartnerAccount || isAuthorized || isReadOnly || !signedInWithCac" />
        <label style="margin-left: 5px; margin-right: 5px" v-if="isBuyTransaction && !isPartnerAccount">or</label>
        <request-signature :signatureUrl="`api/acceptorsignatures/request/${getOrderIdFromRoute}`"
          v-bind:moduleSubmit="submit"
           @update-status="updateStatus"
          :requestDate="authorizedAcceptor.acceptorDateRequested" :isDisabled="isRequestDisabled || refreshKey > 0"
          v-if="isBuyTransaction && !isPartnerAccount"></request-signature>
        <div v-if="hasSignatureImage()" class="container signature_content_padding_top_small signature_field">
          <div class="row justify-content-end">
            <delete-signature :headerText="'Are you sure you want to remove the Acceptor Signature?'"
              :signatureId="authorizedAcceptor.acceptorSignature.signatureId" :fileTypeId="1"
              :signatureType="authorizedAcceptor.acceptorSignature.type" :disabled="isPartnerAccount || isAuthorized"
              v-on:modal-closed="reloadData"></delete-signature>
          </div>

          <img class="image_layout" :src="authorizedAcceptor.acceptorSignature.view" height="100" />
        </div>

        <div>
          <div class="signature_content_padding_top_small">
            <label>Signature Date</label>
            <el-date-picker id="signatureDate"
              :disabled="(isAuthorized && !isLegacyOrder) || isReadOnly || isPartnerAccount || (!isRelevantDocumentUploaded && !fileUploadedBoolean && !uploadedStatus)"
              v-model="authorizedAcceptor.acceptorDateSigned" type="date" :editable="false" format="dd-MMMM-yyyy"
              data-vv-as="Signature Date" name="dateSigned" :class="errors.has('dateSigned') ? 'has-danger' : ''"
              :error="getError('dateSigned')">
            </el-date-picker>
            <span v-show="errors.has('dateSigned')" class="error">Signature Date is required
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 signature_content_padding_top">
        <div class="pull-right">
          <base-button type="primary" wide :disabled="isReadOnly || isAuthorized || checkForPartnerNationCondition"
            @click.native="submit" class="btn-next">Save</base-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import RequestSignature from "@/components/App/signatures/RequestSignature.vue";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";
import VerifyPin from '@/components/App/order/VerifyPin.vue';
import { mapGetters, mapActions } from "vuex";
import { Button } from "element-ui";
import Util from "@/util/util";
import toolTip from "../../../Tooltip";
import { EventBus } from "@/event-bus.js";


export default {
  props: ["isReadOnly", 'uploadedStatus'],
  name: "AuthorizedAcceptorAuthorize",
  data() {
    return {
      isBuyTransaction: true,
      auth_acceptor_tooltip_description: '',
      auth_acceptor_tooltip_name: '',
      fileUploadedBoolean: false,
      isPinVerificationDone: false,
      pin: null,
      sigHasSigned: false,
      refreshKey: 0,
    };
  },
  components: {
    AlertSignature,
    RequestSignature,
    DeleteSignature,
    VerifyPin,
    [Button.name]: Button,
    toolTip
  },

  async mounted() {
    // Load organizations first so dropdown options are available when the saved value is loaded
    await this.loaded();
    
    await this.getAllTooltips();
    this.loadToolTips();

    EventBus.$on('pn-user-change', async (value) => {
      this.loadAuthorizedAcceptor(this.getOrderIdFromRoute);
    });
  },
  computed: {
    ...mapGetters({
      authorizedAcceptor: "authorizedAcceptor/authorizedAcceptor", // Authorize Tab
      preOrderStatus: "preOrderDetail/preOrderStatus",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      getUser: "authentication/getUser",
      agreementInformationStatus:
        "agreementInformation/agreementInformationStatus",
      authorizedAcceptorHelper: "authorizedAcceptor/authorizedAcceptorHelper",
      documents: "documents/getDocuments",
      orderMetadata: "orderMetadata/orderMetadata",
      isAuthorized: "orderMetadata/isAuthorized",
      isSubmitted: "orderMetadata/isSubmitted",
      authorizedAcceptorErrors: "authorizedAcceptor/authorizedAcceptorErrors",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isSigned() {
      if (this.authorizedAcceptor.acceptorDateRequested) {
        if (!this.authorizedAcceptor.acceptorSignature.signatureId) {
          return true
        } else return false
      } else return false
    },
    isRequestDisabled() {
      this.refreshKey;
      return !this.authorizedAcceptor.acceptorName || !this.authorizedAcceptor.acceptorUnitOffice || !this.authorizedAcceptor.acceptorOrganizationId
        || this.authorizedAcceptor.acceptorDateRequested ? true : false || this.authorizedAcceptor.acceptorSignature.view ? true : false || !this.isSubmitted || this.isReadOnly
    },
    isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    isRelevantDocumentUploaded() {
      if (this.documents && this.documents.length > 0) {
        return this.documents.some(document => {
          return document.fileTypeNames.some(doc => doc === Util.TRANSACTION_AUTHORIZATION);
        });
      }
      this.fileUploadedBoolean = false;

      this.$emit('no-document-file-acceptor');
      return false
    },
    checkForPartnerNationCondition() {
      if (this.isPartnerAccount && this.isUsBuyOrder) {
        if (this.authorizedAcceptor.acceptorDateRequested == null) {
          return true;
        }
        return false;
      } else if (this.isPartnerAccount && this.isUsSellOrder) {
        return true;
      }
    },
    signedInWithCac() {
      return this.getUser.loginMethod == "CAC";
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    signatureDateAddedWithSignatureOrDocumentUploaded() {
      return this.isRelevantDocumentUploaded || this.hasSignatureImage() || this.signedInWithCac;
    }
  },
  methods: {
    ...mapActions({
      loadAuthorizedAcceptor: "authorizedAcceptor/getAuthorizedAcceptor",
      getAuthorizedAcceptorAuthorizeStatus: "authorizedAcceptor/getAuthorizedAcceptorAuthorizeStatus",
      getAuthorizedAcceptorHelper: "authorizedAcceptor/getAuthorizedAcceptorHelper",
      saveAuthorizedAcceptorToServer: "authorizedAcceptor/saveAuthorizedAcceptor",
      getAllTooltips: "tooltip/getToolTips",
      getAuthorizedAcceptorSignOnly: "authorizedAcceptor/getAuthorizedAcceptorSignOnly"
    }),
    pinVerify(val, pin) {
      this.isPinVerificationDone = val;
      this.pin = pin;
    },
    updateStatus() {
      this.refreshKey++;
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'TRANSACTION AUTHORIZATION')
    },

    async loaded() {
      let ctx = this;
      
      await ctx.getAuthorizedAcceptorHelper(ctx.getOrderIdFromRoute);
      
      const params = {
        buySell: ctx.authorizedAcceptorHelper.buySell,
        countryId: ctx.authorizedAcceptorHelper.countryId,
        preOrderDetailStatus: ctx.preOrderStatus,
        agreementInformationStatus: ctx.agreementInformationStatus,
      };

      this.isBuyTransaction = params.buySell == "BUY";

      await ctx.$store.dispatch(
        "authorizedAcceptor/getOrganizations",
        params
      );
      
      await ctx.loadAuthorizedAcceptor(this.getOrderIdFromRoute);
    },
    async onSigned() {
      // complete the request
      this.sigHasSigned = true;
      await this.submit();
      // only pn user will use this

      this.pin = null;
    },
    async fileUploaded() {
      this.fileUploadedBoolean = true;
      this.$emit('transaction-acceptor-file-uploaded', true);
      // reload the signature view
      await this.getAuthorizedAcceptorSignOnly(this.getOrderIdFromRoute);
      await this.submit();
      this.$loaderApp.completeRequest();

    },
    loadToolTips() {
      const authAcceptorToolTip = this.toolTips.find(e => e.name === "AuthAcceptorSignature")
      if (authAcceptorToolTip.status) {
        this.auth_acceptor_tooltip_description = authAcceptorToolTip.description ? authAcceptorToolTip.description : null
        this.auth_acceptor_tooltip_name = authAcceptorToolTip.name ? authAcceptorToolTip.name : null
      }
      return
    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },

    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.authorizedAcceptor.acceptorSignature.view);
    },
    async reloadData() {
      await this.getAuthorizedAcceptorAuthorizeStatus(this.getOrderIdFromRoute);
      // everywhere is reloading this in the submit
      await this.loadAuthorizedAcceptor(this.getOrderIdFromRoute);
    },

    async submit(e) {
      let result = await this.$validator.validateAll(); //.then((result) => {
      if (result) {
        this.$loaderApp.addRequest();
        if (!this.signatureDateAddedWithSignatureOrDocumentUploaded && this.authorizedAcceptor.acceptorDateSigned) {
          this.authorizedAcceptor.acceptorDateSigned = null;
          this.$toast.error(Util.SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED);
        }

        let ctx = this;
        let data = {
          orderId: this.getOrderIdFromRoute,
          pin: (this.sigHasSigned || this.fileUploadedBoolean) ? this.pin : ''
        }

        try {
          await this.saveAuthorizedAcceptorToServer(data);
          await ctx.getAuthorizedAcceptorAuthorizeStatus(ctx.getOrderIdFromRoute);
          // everywhere is reloading this in the submit
          await this.loadAuthorizedAcceptor(this.getOrderIdFromRoute);
          ctx.$toast.success("Authorized Acceptor Module signature saved successfully");
          this.$loaderApp.completeRequest();
        }

        catch (errorMessage) {
          this.$toast.error(errorMessage);
          this.$loaderApp.completeRequest();
        };

      } else {
        this.$toast.error("Please fill the form required fields.");
        this.$loaderApp.completeRequest();
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
};
</script>
<style scopped>
.row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.signature_field img {
  user-drag: none;
  -webkit-user-drag: none;
}
</style>